import styled from 'styled-components'

export const Icon = styled.div`
  color: inherit;
  display: flex;
  font-size: inherit;
  line-height: normal;

  svg{
    font-size: 2.2rem;
  }
`
